import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {getActiveMobileTabId, getMobileTabs, MobileTab} from '../../../@core/utils/mobile-access.util';
import {PlatformService} from '../../../@core/utils/platform.service';
import {SessionService} from '../../../@core/utils/session.service';
import {AppSidebarService} from '../../prime/app-sidebar.service';
import {filter, Subscription} from 'rxjs';

@Component({
	standalone: false,
	selector: 'app-mobile-tab-bar',
	templateUrl: './app-mobile-tab-bar.component.html',
	styleUrls: ['./app-mobile-tab-bar.component.scss'],
})
export class AppMobileTabBarComponent implements OnInit, OnDestroy {
	tabs: MobileTab[] = [];
	activeTabId: MobileTab['id'] | null = null;
	sidebarOpen = false;
	private sessionSub?: Subscription;
	private sidebarSub?: Subscription;

	constructor(
		private platformService: PlatformService,
		private sessionService: SessionService,
		private router: Router,
		private sidebarService: AppSidebarService,
		private cd: ChangeDetectorRef,
	) {
		this.syncActiveTab(this.router.url);
		this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
			this.syncActiveTab((event as NavigationEnd).urlAfterRedirects);
		});
	}

	ngOnInit(): void {
		this.refreshTabs();
		this.sessionSub = new Subscription();
		this.sessionSub.add(this.sessionService.getPermissionChangeEmitter().subscribe(() => {
			this.refreshTabs();
		}));
		this.sessionSub.add(this.sessionService.getRestaurantChangeEmitter().subscribe(() => {
			this.refreshTabs();
		}));
		this.sidebarSub = this.sidebarService.getSidebarState('menu-sidebar').subscribe((state) => {
			this.sidebarOpen = state === 'expanded';
			this.cd.markForCheck();
		});
	}

	ngOnDestroy(): void {
		this.sessionSub?.unsubscribe();
		this.sidebarSub?.unsubscribe();
	}

	get visible(): boolean {
		return this.platformService.isMobileApp() && this.tabs.length > 0;
	}

	navigate(tab: MobileTab): void {
		if (tab.opensSidebar) {
			if (this.sidebarOpen) {
				this.sidebarService.collapse('menu-sidebar');
			} else {
				this.sidebarService.expand('menu-sidebar');
			}
			return;
		}

		if (this.sidebarOpen) {
			this.sidebarService.collapse('menu-sidebar');
		}

		if (this.activeTabId === tab.id && this.router.url.split('?')[0] === tab.route) {
			return;
		}

		void this.router.navigateByUrl(tab.route);
	}

	isActive(tab: MobileTab): boolean {
		if (this.sidebarOpen) {
			return !!tab.opensSidebar;
		}
		return this.activeTabId === tab.id;
	}

	private refreshTabs(): void {
		this.tabs = getMobileTabs(this.sessionService);
		this.syncActiveTab(this.router.url);
		this.cd.markForCheck();
	}

	private syncActiveTab(url: string): void {
		this.activeTabId = getActiveMobileTabId(url, this.sessionService);
	}
}
